import { useEffect } from 'react';
import Cookies from 'js-cookie';
import isEqual from 'lodash/isEqual';
import { SESSION_TRACKING_ENTRY_ID } from '../constants/cookiesConstants';
import { isInAppWebView, logFirebaseEvent } from './webViewBridge';
const nativeAppEntries = [];
export const getDataLayerEntries = () => isInAppWebView() ? nativeAppEntries : window.dataLayer;
export const entryExistsInDataLayer = entry => {
  var _getDataLayerEntries;
  return Boolean((_getDataLayerEntries = getDataLayerEntries()) === null || _getDataLayerEntries === void 0 ? void 0 : _getDataLayerEntries.some(dataLayerEntry => isEqual(dataLayerEntry, entry)));
};
export const keyExistsInDataLayer = key => {
  var _getDataLayerEntries2;
  return Boolean((_getDataLayerEntries2 = getDataLayerEntries()) === null || _getDataLayerEntries2 === void 0 ? void 0 : _getDataLayerEntries2.some(dataLayerEntry => Object.keys(dataLayerEntry).includes(key)));
};
const pushEntryToNativeApp = entry => {
  const {
    event,
    ...parameters
  } = entry;
  if (!event) {
    return;
  }
  nativeAppEntries.push(entry);
  logFirebaseEvent(event, parameters);
};
export const pushEntryToDataLayer = (entry, allowDuplicate = true) => {
  if (!allowDuplicate && entryExistsInDataLayer(entry)) {
    return;
  }
  if (isInAppWebView()) {
    pushEntryToNativeApp(entry);
    return;
  }
  const {
    dataLayer
  } = window;
  if (dataLayer) {
    dataLayer.push(entry);
  }
};
export const pushToDataLayer = (...entries) => {
  entries.forEach(entry => pushEntryToDataLayer(entry, false));
};
export const getSiteContextProperties = ({
  market,
  entryType,
  partner,
  siteCurrency: currency,
  siteName
} = {}) => {
  const siteCountry = market === null || market === void 0 ? void 0 : market.code;
  const siteCurrency = currency === null || currency === void 0 ? void 0 : currency.code;
  return {
    siteName,
    siteCountry,
    entryType,
    partner,
    siteCurrency
  };
};
export const getSiteInitialData = (siteContext, storeSessionTrackingEntryInDataLayer) => {
  const sessionTrackingEntryId = Cookies.get(SESSION_TRACKING_ENTRY_ID);
  const siteInitialData = getSiteContextProperties(siteContext);
  if (sessionTrackingEntryId && storeSessionTrackingEntryInDataLayer) {
    siteInitialData.ibeSteId = sessionTrackingEntryId;
  }
  return siteInitialData;
};
export const useGADataLayerEffect = (...args) => {
  useEffect(() => {
    pushToDataLayer(...args);
    // oxlint-disable-next-line react/exhaustive-deps
  }, []);
};
export const logMouseFlowTag = tag => {
  const mouseFlowWindow = window;
  mouseFlowWindow._mfq = mouseFlowWindow._mfq || [];
  mouseFlowWindow._mfq.push(['tag', tag]);
};
export const useLogMouseFlowTagEffect = (tag, condition = true) => {
  useEffect(() => {
    if (condition) {
      logMouseFlowTag(tag);
    }
  }, [condition, tag]);
};
export { isInAppWebView, logFirebaseEvent } from './webViewBridge';
//# sourceMappingURL=index.js.map